/*!
 *  - ir.js
 * @generated Thu Jan 16 2020 12:35:49 GMT+0900 (東京 (標準時))
 */
'use strict';

(function ($, DIC) {
	var a = 'is-active';
	var v = 'is-visible';
	var f = 'is-fixed';
	var slideSpeed = '400';

	var slider = function slider() {};

	slider();
})(window.jQuery, window.DIC);